// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.profile-img-container img[data-v-366c6a00] {\n  width: 25px;\n  height: 25px;\n  background: rgb(19, 13, 13);\n  border-radius: 50%;\n}\n.profile-label[data-v-366c6a00] {\n  font-size: 0.85rem;\n  color: var(--green);\n  font-weight: 400;\n}\n.pi.pi-angle-down[data-v-366c6a00] {\n  font-size: 1rem !important;\n  opacity: 0.85;\n}\n.dropdown-menu[data-v-366c6a00] {\n  min-width: 110%;\n}\n", ""]);
// Exports
module.exports = exports;
